import React from 'react';

import {getSortOptions} from 'app/general/dashboards/DashboardFilterbarSort';
import {FormItem} from 'app/general/widgets/BaseFormField';
import {
  useAccountSettings,
  useSetDefaultDocumentsOrdering,
} from 'app/settings/api';
import {SORT_BY_TYPES} from 'app/utils/constants';
import {gt} from 'app/utils/i18n';

const ORDERING_OPTIONS = [
  SORT_BY_TYPES.ALPHABETHICALLY,
  SORT_BY_TYPES.MODIFICATION_DATE,
  SORT_BY_TYPES.CREATION_DATE,
  SORT_BY_TYPES.APPROVED_DATE_DESC,
  SORT_BY_TYPES.REVIEWED_DATE_DESC,
  SORT_BY_TYPES.REVIEWED_DATE_ASC,
  SORT_BY_TYPES.REVIEWED_DATE_NEXT_ASC,
];

const optionsWithLabels = getSortOptions(ORDERING_OPTIONS);

export function DefaultDocumentsOrderingForm(): JSX.Element {
  const {data: settings} = useAccountSettings();
  const [setOrdering, {isLoading}] = useSetDefaultDocumentsOrdering();

  const current =
    settings?.default_documents_ordering ?? SORT_BY_TYPES.MODIFICATION_DATE;

  const handleChange = (ev: React.ChangeEvent<HTMLSelectElement>) => {
    if (!settings) return;
    setOrdering({
      account_id: settings.account_id,
      default_documents_ordering: ev.target.value,
    });
  };

  return (
    <FormItem
      id="id_default_documents_ordering"
      label={gt('Default documents ordering')}
      helpText={gt(
        'Default sort order for all document dashboards when no ordering is manually selected.'
      )}
    >
      <div className="col-12 col-sm-10 col-md-6">
        <select
          id="id_default_documents_ordering"
          className="form-control"
          value={current}
          onChange={handleChange}
          disabled={isLoading}
        >
          {optionsWithLabels.map(({value, text}) => (
            <option key={value} value={value}>
              {text}
            </option>
          ))}
        </select>
      </div>
    </FormItem>
  );
}
